<template>
    <modal class="imagePreview" :isShow="isShow">
        <div class="header">台号：{{title}}</div>
        <div class="modal-body">
            <qr-code v-if="url" :text="url" :width="350" :height="350"/>
            <div v-else class="error-text">
                桌台没有二维码信息，请后台查看！
            </div>
        </div>
        <div class="footer-box">
            <button class="btn btn-confirm" @click="confirm()">确认</button>
        </div>
    </modal>
</template>

<script>
export default {
    name:"imagePreview",
    emits:["close"],
    props:{
        isShow:{
            type:Boolean,
            default:false
        },
        title:{
            type:String,
            default:""
        },
        url:{
            type:String,
            default:""
        }
    },
    methods:{
        confirm(){
            this.$emit("close");
        }
    }
}
</script>

<style lang="scss">
.imagePreview{
    .modal-dialog{ 
        width:400px;
        max-width:400px;
       
        .modal-content{
            right: inherit;
            width: 100%;
            border-radius: 8px;
            padding-bottom: 0px;
        }
    }
 
    .header{
       background: #DCE2EA;
       height: 45px;
       line-height: 45px;
       padding-left: 20px;
       border-radius: 8px;
       border-bottom-left-radius:0 ;
       border-bottom-right-radius:0 ;
       font-weight: bold;
       font-size: 18px;
       color: #333;
    }

    .modal-body{
        padding:0;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 370px;
        
        .error-text{
            color: red;
        }
    }

    .footer-box{
        text-align:center;

        .btn{
            width: 100%;
            height: 50px;
            color: #477BB0;
        }
    }
}
</style>